var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicroscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon icon-tabler icons-tabler-outline icon-tabler-microscope",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21h14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18v3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11l3 3l6 -6l-3 -3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.5l-1.5 1.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3l3 3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21a6 6 0 0 0 3.715 -10.712"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscope);
export default __webpack_public_path__ + "static/media/microscope.23ffc850acbdd0937ef3193e85e8cb72.svg";
export { ForwardRef as ReactComponent };